import { PositionUnit } from '@shure/shared/angular/utils/utils-position';

import { PassiveSpeaker } from '../../api/models';
import { DeviceCoveragePassiveSpeakerFragment } from '../graphql/generated/device-coverage-audio-passive-speaker.generated';

export function mapDeviceCoveragePassiveSpeakers(fragment: DeviceCoveragePassiveSpeakerFragment): PassiveSpeaker {
	const { description, features } = fragment;

	return {
		id: fragment.id,
		description: {
			constraints: {
				listenerHeight: {
					height: {
						range: {
							max: PositionUnit.fromRaw(description?.constraints?.listenerHeight?.height?.range.max ?? 0),
							min: PositionUnit.fromRaw(description?.constraints?.listenerHeight?.height?.range.min ?? 0),
							step: PositionUnit.fromRaw(
								description?.constraints?.listenerHeight?.height?.range.step ?? 0
							)
						}
					}
				}
			}
		},
		features: {
			position: {
				x: PositionUnit.fromRaw(features.coveragePosition?.xPosition ?? 0),
				y: PositionUnit.fromRaw(features.coveragePosition?.yPosition ?? 0)
			},
			rotation: {
				xAxis: features.rotation?.xAxis ?? 0,
				yAxis: features.rotation?.yAxis,
				zAxis: features.rotation?.zAxis ?? 0
			},
			height: PositionUnit.fromRaw(features.height?.height ?? 0),
			listenerHeight: PositionUnit.fromRaw(features.listenerHeight?.height ?? 0)
		}
	};
}
